module.exports = __webpack_public_path__ + "static/media/Master-2.ca35d3ab.webp";